<div [hidden]="!fundPerformanceData?.length">
  <div edsGrid>
    <div edsRow>
      <div
        edsCol
        [columnNumbers]="{ s: '4', m: '8', l: '12' }"
        class="table--wrapper"
      >
        <div class="table--scroll">
          <!--
            WDE-2554
            Display none is used so cards can
            be generated from the table content
          -->
          <table
            [style.display]="(isHandheld$ | async) ? 'none' : ''"
            class="table"
            #tableResponsive
          >
            <thead>
              <tr class="table__tr">
                <th class="table__th table__th--padding-right-none"></th>
                <th
                  class="table__th table__th--middle"
                  [class.table__th--padding-left-none]="!isAllShareClasses"
                >
                  <p class="spacing--none">
                    {{ tableLabel | translate: fundId }}
                  </p>
                  <p class="small spacing--none">
                    {{ "products.as-of" | translate }}
                    {{ fundPerformanceDates?.asOfDate }}
                  </p>
                </th>
                <th
                  class="table__th text-align-right table__th--middle"
                  *ngIf="fundPerformanceConfig?.showCurrency"
                >
                  <span
                    class="text-align-right"
                    edsFlexbox
                    justifyContent="flex-end"
                  >
                    {{ "products.currency" | translate }}
                  </span>
                </th>
                <th
                  class="table__th text-align-right table__th--middle text-no-wrap"
                  *ngFor="let year of years"
                >
                  <span
                    class="text-align-right"
                    edsFlexbox
                    justifyContent="flex-end"
                  >
                    {{ year?.startDate }} / <br />
                    {{ year?.endDate }}
                  </span>
                </th>
                <th
                  class="table__th text-align-right table__th--middle table__th--middle"
                  [class.table__th--padding-right-none]="isAllShareClasses"
                >
                  <p
                    class="spacing--none text-align-right"
                    edsPadding
                    edsPaddingRight="lg"
                    edsFlexbox
                    justifyContent="flex-end"
                  >
                    {{ "products.inception-date" | translate }}
                  </p>
                </th>
                <th
                  class="table__th text-align-right table__th--middle table__th--padding-left-none"
                  [hidden]="!isAllShareClasses"
                >
                  <p
                    class="spacing--none text-align-right"
                    edsPadding
                    edsPaddingRight="lg"
                    edsFlexbox
                    justifyContent="flex-end"
                  >
                    {{ "products.fund-info-perf" | translate }}
                  </p>
                </th>
              </tr>
            </thead>
            <tbody class="table__body">
              <tr class="table__tr" *ngFor="let row of fundPerformanceData">
                <td class="table__td table__td--padding-right-none">
                  <span
                    [hidden]="isAllShareClasses || row?.hideOnChart"
                    class="table__legend"
                    edsSpacing
                    ><span
                      class="table__legend-box"
                      [style.background]="row?.pointColor"
                    ></span
                  ></span>
                </td>
                <td
                  class="table__td"
                  [class.table__td--padding-left-none]="!isAllShareClasses"
                >
                  {{ row?.name }}
                  <ng-container *ngIf="row?.calcTypeLabel">
                    {{ row?.calcTypeLabel | translate }}
                  </ng-container>
                  <span class="text-no-wrap">
                    {{ "(%)" }}
                  </span>
                  <eds-footnote
                    [hidden]="isAllShareClasses"
                    [placement]="'Discrete:' + row?.placement"
                  ></eds-footnote>
                </td>
                <td
                  class="table__td text-align-right"
                  *ngIf="fundPerformanceConfig?.showCurrency"
                >
                  {{ row?.currency }}
                </td>
                <td
                  class="table__td text-align-right"
                  *ngFor="let col of tableCols"
                >
                  <span
                    class="text-align-right"
                    edsFlexbox
                    justifyContent="flex-end"
                  >
                    {{ row[col] }}
                  </span>
                </td>
                <td
                  class="table__td text-align-right"
                  [class.table__td--padding-right-none]="isAllShareClasses"
                >
                  <span edsPadding edsPaddingRight="lg">{{
                    row?.inceptionDate
                  }}</span>
                </td>
                <td
                  class="table__td text-align-center table__td--padding-left-none"
                  [hidden]="!isAllShareClasses"
                >
                  <eds-link-item
                    [title]="'products.fund-information-perf' | translate"
                    [href]="row?.link"
                    edsFlexbox
                    justifyContent="center"
                  ></eds-link-item>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div edsRow *ngFor="let card of cards; let cardIndex = index">
      <div edsCol *ngIf="(isHandheld$ | async) === true">
        <eds-panel
          edsSpacing="sm"
          [hasBorders]="true"
          [hasBorderRadius]="false"
          [hasPadding]="true"
        >
          <eds-info-item
            *ngFor="let item of card; let itemIndex = index"
            [info]="item"
            edsSpacing="sm"
          >
            <div
              [style.display]="
                !isAllShareClasses && itemIndex === 0 && removeValue(item)
                  ? 'block'
                  : 'none'
              "
            >
              <span
                class="table__legend"
                edsPadding
                edsPaddingLeft="xs"
                edsFlexbox
                alignItems="flex-start"
              >
                <span
                  class="table__legend-box table__legend-box--spacing-none"
                  [style.background]="
                    fundPerformanceData[cardIndex]?.pointColor
                  "
                ></span>
                <span edsPadding edsPaddingLeft="xs">
                  {{ fundPerformanceData[cardIndex]?.name }}
                  <ng-container
                    *ngIf="fundPerformanceData[cardIndex]?.calcTypeLabel"
                  >
                    {{
                      fundPerformanceData[cardIndex]?.calcTypeLabel | translate
                    }}
                  </ng-container>
                  {{ "(%)" }}
                  <eds-footnote
                    [placement]="
                      'Discrete:' + fundPerformanceData[cardIndex]?.placement
                    "
                  ></eds-footnote>
                </span>
              </span>
            </div>
            <div
              [style.display]="
                isAllShareClasses &&
                itemIndex === card?.length - 1 &&
                removeValue(item)
                  ? ''
                  : 'none'
              "
            >
              <eds-link-item
                [title]="'products.fund-information-perf' | translate"
                [href]="fundPerformanceData[cardIndex]?.link"
                [forceRightAlign]="(isHandheld$ | async) === true"
              ></eds-link-item>
            </div>
          </eds-info-item>
        </eds-panel>
      </div>
    </div>
  </div>
</div>
